var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.298,
    height: 27.817,
    viewBox: "0 0 27.298 27.817",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: -0.098,
    x2: 0.418,
    y2: 0.624,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4af18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e919"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new-svgrepo-com",
    transform: "translate(-14.46 -9.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11905",
    "data-name": "Path 11905",
    d: "M20.765,33.388c.434-1.108,3.779-9.1,10.576-10.63a.048.048,0,0,0,0-.1C30.2,22.2,23.2,19.145,20.969,11.818a.048.048,0,0,0-.1,0c-.273,1.215-2.109,7.723-10.7,10.7a.054.054,0,0,0,0,.1c1.2.2,7.215,1.681,10.5,10.785a.054.054,0,0,0,.1-.021Z",
    transform: "translate(4.328 4.268)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11906",
    "data-name": "Path 11906",
    d: "M46.911,21.255c.213-.543,1.85-4.456,5.183-5.205V16a8.929,8.929,0,0,1-5.08-5.308h-.051a7.546,7.546,0,0,1-5.242,5.235v.051c.587.1,3.531.822,5.139,5.286Z",
    transform: "translate(-10.336 -0.808)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.a4bddcd79a0ca4eb1d3785cdc1d9da40.svg";
export { ForwardRef as ReactComponent };